<template>
  <PCHeaderBar />
  
  <div class="pc__new-arrival">
    <div class="pc__new-arrival-inner">
      <div class="tips" v-if="!!tips">
        <p v-html="tips"></p>
      </div>

      <div class="header-bar-wrapper">
        <SearchBar :filters="filter" :sort-list="sortList" @search="onSearch" />
      </div>

      <div class="listings">
        <div
          v-for="item in previewListings"
          :key="item.id"
          class="listing-item"
        >
          <PCProductItemCard show-add-cart type="normal" :product-data="item" @add-cart="handleAddCart" />
        </div>
        <div class="empty" v-show="previewListings.length <= 0">
          <img v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/new_wap/cart/cart_default_bg@2x.png')" alt="">
          <p>Not match any products!</p>
        </div>
      </div>

      <div class="load-more" @click="handleLoadMoreClick" v-if="!finished">
        <span class="loading" v-show="loading">
          <van-loading size="20px" color="#DD3131" type="spinner" />
        </span>
        <span>SHOW MORE</span>
      </div>
    </div>

    <ClientOnly>
    <SkuSelectPopup
      v-model:visible="skuSelectVisible"
      :listingId="currentListing.id"
      :defaultSkuId="currentListing.skuId"
      popup-position="center"
      @add-cart:success="emits('add-cart:success')"
    />
  </ClientOnly>
  </div>

  <PCFooter />
</template>

<script setup lang="ts">
import type { ISearchParams } from '~/api/models/system';
import SearchBar from './SearchBar.vue';
import { type ICategory, type ISort } from '@/pages/search.vue' 
import SkuSelectPopup from '@/pages/promotion-listings/widgets/_SelectSku.vue'

interface IProps {
  tips: string,
  promotionListings: any[]
  finished: boolean
  loading: boolean
  categoryList: ICategory[]
  filter: any
  sortList: ISort[]
}

const props = defineProps<IProps>()
const emits = defineEmits<{ 
  (e: 'load'): void,
  (e: 'search', p: ISearchParams): void
  (e: 'add-cart:success'): void
}>()
const previewListings = computed(() => props.promotionListings.map(c => ({ ...c })))

const handleLoadMoreClick = () => {
  emits('load')
}

const currentSearchParams = ref<ISearchParams>({})

const onSearch = (p: ISearchParams) => {
  currentSearchParams.value = p
  emits('search', currentSearchParams.value)
}

const skuSelectVisible = ref<boolean>(false)
const currentListing = ref<{ id: number, skuId: number }>({ id: 0, skuId: 0 })
const handleAddCart = (listing: any) => {
  currentListing.value.id = listing.listingId
  currentListing.value.skuId = listing.defaultSkuId
  skuSelectVisible.value = true
}
</script>

<style lang="scss" scoped>
.pc__new-arrival{
  .pc__new-arrival-inner{
    width: var(--viewport-width);
    margin: 0 auto;
    padding-bottom: 80px;
  }
}

.tips{
  height: 64px;
  line-height: 64px;
  color: var(--main_color);
  padding: 0 30px;
  background: linear-gradient(90deg, #FFE4D4 0%, #FFDCE6 100%);
}

.listings{
  margin: 0 -20px;
  display: flex;
  flex-wrap: wrap;

  .listing-item{
    width: 20%;
    padding: 20px;
  }
}

.load-more{
  margin: 80px auto;
  border: 2px solid #efefef;
  box-shadow: 0 0 4px #666;
  text-align: center;
  cursor: pointer;
  height: 80px;
  @include center();
  width: 600px;
  color: #666;
  font-weight: 800;
  .loading{
    margin-right: 16px;
  }
}
.empty{
  text-align: center;
  width: 100%;
  img{
    width: 600px;
  }
  p{
    margin-top: 40px;
    font-weight: 600;
  }
}
</style>
